import { CSSProperties } from 'react'

const StarRating = ({ color = '#151515', style }: { color?: string; style?: CSSProperties }) => {
    return (
        <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
                <path
                    d="M18.3337 8.11658L12.342 7.59992L10.0003 2.08325L7.65866 7.60825L1.66699 8.11658L6.21699 12.0583L4.85033 17.9166L10.0003 14.8083L15.1503 17.9166L13.792 12.0583L18.3337 8.11658ZM10.0003 13.2499L6.86699 15.1416L7.70033 11.5749L4.93366 9.17492L8.58366 8.85825L10.0003 5.49992L11.4253 8.86659L15.0753 9.18325L12.3087 11.5833L13.142 15.1499L10.0003 13.2499Z"
                    fill={color}
                />
            </svg>
        </div>
    )
}

export default StarRating
